import { CodexMarketplace, CodexData, CodexNode, CodexDebug } from './chunk-B23RMVB7.mjs';
export { CodexCreateAvailabilityInput, CodexCreateStorageRequestInput, CodexData, CodexDebug, CodexError, CodexLogLevel, CodexMarketplace, CodexNode, CodexUpdateAvailabilityInput, CodexValibotIssuesMap, Fetch } from './chunk-B23RMVB7.mjs';

// src/index.ts
var Codex = class {
  url;
  _marketplace;
  _data;
  _node;
  _debug;
  constructor(url) {
    this.url = url;
    this._marketplace = null;
    this._data = null;
    this._node = null;
    this._debug = null;
  }
  get marketplace() {
    if (this._marketplace) {
      return this._marketplace;
    }
    this._marketplace = new CodexMarketplace(this.url);
    return this._marketplace;
  }
  get data() {
    if (this._data) {
      return this._data;
    }
    this._data = new CodexData(this.url);
    return this._data;
  }
  get node() {
    if (this._node) {
      return this._node;
    }
    this._node = new CodexNode(this.url);
    return this._node;
  }
  get debug() {
    if (this._debug) {
      return this._debug;
    }
    this._debug = new CodexDebug(this.url);
    return this._debug;
  }
};

export { Codex };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map